import { apiClient } from '@/services/ApiClient.js'

export default {
  getSupplierContacts(supplierId) {
    return apiClient
      .get('suppliers/' + supplierId + '/supplier-contacts')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createSupplierContact(supplierId, supplierContact) {
    return apiClient
      .post('suppliers/' + supplierId + '/supplier-contacts', supplierContact)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  editSupplierContact(supplierId, supplierContactId, supplierContact) {
    return apiClient
      .patch('suppliers/' + supplierId + '/supplier-contacts/' + supplierContactId, supplierContact)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteSupplierContact(supplierId, supplierContactId) {
    return apiClient
      .delete('suppliers/' + supplierId + '/supplier-contacts/' + supplierContactId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
